import React from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';
import FeatureComparisonTable from './FeatureComparisonTable';

const FeatureComparisonSection = () => (
  <Box>
    <Heading
      w="100%"
      textAlign="center"
      fontWeight="bold"
      fontSize={['2xl', '3xl', '4xl', '5xl']}
      mb="10"
      px={['10', '16', '32']}
    >
      Choose the plan that suits your team.
    </Heading>

    <Text w="100%" textAlign="center" mb={['16', '20']}>
      Take a look at the breakdown of our offerings to find the best plan for
      your business.
    </Text>

    <FeatureComparisonTable />
  </Box>
);

export default FeatureComparisonSection;
